// @flow

import { type IncomingPayment } from './types';

export function getMerchantPaymentCode(incomingPayment: IncomingPayment): string {
  return incomingPayment['merchant_payment_code'];
}
